import api, { createApiService } from "../http"
import { RequestGetAll } from "../types/services-types/http-types"
import { IRegistryNotVerify } from "../types/services-types/registry-types"

export default class RegistryNotVerifyService {

    static apiRegistryNotVerifyService = createApiService('/registry-not-verify')

    static async AddFromExcel(formData: FormData) {
        const response = await this.apiRegistryNotVerifyService.post<IRegistryNotVerify[]>('/add-from-excel', formData)
        return response.data
    }


    static async Add(json: Object) {
        const response = await this.apiRegistryNotVerifyService.post<IRegistryNotVerify>('/add', json)
        return response.data
    }

    static async Update(data: Object) {
        const response = await this.apiRegistryNotVerifyService.post<IRegistryNotVerify>(`/update`, data)
        return response.data
    }

    static async Get(id: number) {
        const response = await this.apiRegistryNotVerifyService.get<IRegistryNotVerify>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: number, page: number) {
        const response = await this.apiRegistryNotVerifyService.get<RequestGetAll<IRegistryNotVerify[]>>('/all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllFilters(limit: number, page: number, form: Object) {
        const response = await this.apiRegistryNotVerifyService.get<RequestGetAll<IRegistryNotVerify[]>>('/all-filters', {
            params: {
                ...form,
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number) {
        const response = await this.apiRegistryNotVerifyService.post(`/delete/${id}`)
        return response.data
        
    }
}